import React from 'react';
import { generatePath } from 'react-router-dom';
import { AlertType, useAlert } from 'src/components/AlertsProvider';
import {
  ModalCloseHandler,
  ModalCloseReason,
} from 'src/components/ModalDialog';
import { pepApiRequest, RequestMethod, useStatefulApi } from 'src/services';
import { API_PLATFORM_VERSION_ITEM } from '../constants';
import { PlatformVersionItem } from '../types';
import EditPlatformVersionModal from './EditPlatformVersionModal';

type Props = {
  item: PlatformVersionItem;
  open: boolean;
  onClose: ModalCloseHandler;
};

function EditPlatformVersionModalContainer({ item, open, onClose }: Props) {
  const { showAlert } = useAlert();
  const { id, edgeComponentName } = item || {};
  const [handleSubmit, loading] = useStatefulApi(
    (params: PlatformVersionItem) =>
      pepApiRequest({
        method: RequestMethod.Put,
        url: generatePath(API_PLATFORM_VERSION_ITEM, { id }),
        useProxy: false,
        params: { ...params, id },
      }),
    () => {
      showAlert({
        type: AlertType.Success,
        title: `${edgeComponentName} is updated`,
        text: 'Platform version has been successfully updated.',
      });
      onClose(null, ModalCloseReason.completeAction);
    }
  );

  return (
    <EditPlatformVersionModal
      title="Edit platform version"
      open={open}
      onSubmit={handleSubmit}
      onClose={onClose}
      loading={loading}
      item={item}
    />
  );
}

export default EditPlatformVersionModalContainer;
